export default {
    defaultProps: {
        underline: 'hover',
    },
    styleOverrides: {
        root: ({ ownerState: { disabled } }) => ({
            cursor: 'pointer',

            '&:hover': disabled
                ? {
                      cursor: 'not-allowed',
                      textDecoration: 'none',
                  }
                : {
                      filter: 'brightness(0.85)',
                  },
        }),
    },
};
